import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setDone(data); // may include reset_url in dev
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  const inputCls = "w-full bg-white border border-border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary";

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-md bg-forest grid place-items-center text-white">
            <ShieldCheck className="w-5 h-5" strokeWidth={1.5} />
          </div>
          <div className="font-display font-bold text-lg">KREPP</div>
        </div>
        <div className="label mb-2">Account recovery</div>
        <h2 className="font-display text-3xl font-semibold tracking-tight mb-6">Reset your password</h2>

        {!done ? (
          <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
            <div>
              <label className="label block mb-2">Email</label>
              <input type="email" required className={inputCls} value={email}
                     onChange={(e) => setEmail(e.target.value)}
                     data-testid="forgot-email-input" autoComplete="email" />
            </div>
            {err && <div className="text-sm text-secondary" data-testid="forgot-error">{err}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full py-3" data-testid="forgot-submit-btn">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        ) : (
          <div className="card-flat p-6" data-testid="forgot-success">
            <div className="text-sm">If the email exists, a reset link has been sent. Check your inbox (and spam).</div>
            {done.reset_url && (
              <div className="mt-4 p-3 bg-muted rounded-md text-xs break-all" data-testid="dev-reset-url">
                <div className="label mb-2">Dev convenience (SendGrid not configured)</div>
                <a href={done.reset_url} className="text-forest underline">{done.reset_url}</a>
              </div>
            )}
          </div>
        )}

        <div className="mt-8 text-sm text-muted-foreground">
          <Link to="/login" className="text-forest font-medium hover:underline" data-testid="back-to-login">
            ← Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
